export const hasNoSpacesRegExp = /^\S*$/;
